import { render, staticRenderFns } from "./SimulationAudienceForm.vue?vue&type=template&id=2406fab8&"
import script from "./SimulationAudienceForm.vue?vue&type=script&lang=js&"
export * from "./SimulationAudienceForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports